module.exports = __webpack_public_path__ + "static/media/portrait4.bec32aab.png";